import dayjs from 'dayjs';
import { normalizeAccessOptions } from '~/utils/access-helper';

/**
 * Middleware to check if the user has access to the page
 * @param {Route} to
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
    const nuxtApp = useNuxtApp();
    // Don't run on client hydration when server rendered
    if (
        import.meta.client &&
        nuxtApp.isHydrating &&
        nuxtApp.payload.serverRendered
    ) {
        return;
    }

    // Get the access options from the route meta
    const accessOptions = normalizeAccessOptions(to.meta?.access);

    // Token Cookie
    const refreshTokenCookie = useCookie('px.refreshToken');

    // If the refresh token cookie is not set return
    if (!refreshTokenCookie.value) {
        return;
    }

    // User session
    const { loggedIn, fetch: fetchSession, session } = useUserSession();

    // Check if expiresAt date on session is in the past
    const isExpired = isSessionExpired(session);

    if (loggedIn.value && !isExpired) {
        return;
    }
    // Refresh the access token
    const [refreshError, _] = await catchError(refreshAccessToken());

    if (refreshError && accessOptions.type === 'guest') {
        // If there was an error refreshing the token, redirect to login
        refreshTokenCookie.value = null;

        return;
    }

    if (refreshError) {
        // If there was an error refreshing the token, redirect to login
        refreshTokenCookie.value = null;
        return await abortNavigation({
            statusCode: 401,
            statusMessage: 'Unauthorized',
        });
    }

    // refresh the session
    await fetchSession();
});
